// extracted by mini-css-extract-plugin
export default {"attentionBanner":"tceOH32Gxh3B2eFtjC6g","normal":"AT48Oz4NbCLNRjhPas8K"};